function getBrowserWidth() {
  return document.documentElement.clientWidth || window.innerWidth;
}

export { getBrowserWidth };
